<div class="minimized-dialog-holder">
  <div class="minimized-dialog"
       [ngClass]="{'small': dialogRefs.length>limitOfDialogsBeforeChangeStyleToSmall}"
       id="{{dialogRef.id}}"
       *ngFor="let dialogRef of dialogRefs">
    <div class="title" (click)="maximizeDialog(dialogRef)">{{dialogRef.componentInstance.data.eventItem.name}}</div>
    <div class="dialog-buttons-holder">
      <div class="exit-button icon-low-double-line" (click)="minimizeDialog(dialogRef)"></div>
      <div class="exit-button icon-square" (click)="maximizeDialog(dialogRef)"></div>
      <div class="exit-button icon-x" (click)="closeDialog(dialogRef)"></div>
    </div>
  </div>
</div>
